import { RsaAlert } from "@rsa/react-libraries/";
import { useEffect, useState } from "react";

const Alert = () => {
    const commsApi = window.env.REACT_APP_COMMS_API_URL;

    const [alerts, setAlerts] = useState([]);

    useEffect(() => {
        fetch(commsApi + '/messages/active?clientId=HLL')
            .then(response => response.json())
            .then(data => setAlerts(data))
            .catch(error => console.error(error));
    }, []);

    return (
        <ul style={{ listStyle: 'none', paddingLeft: '0' }}>
            {alerts.map(alert => (
                <div className="alert" key={alert.id}>
                    {<RsaAlert
                        alertType={alert.level.toLowerCase()}
                        noIcon={false}
                        autoDismiss={false}
                        headerText={alert.title}
                        role="alert"
                        id="site-alert">
                        {alert.body}
                    </RsaAlert>}
                </div>
            ))}
        </ul>
    );
};

export default Alert;